import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKebabRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.4 7.2a2.4 2.4 0 1 1-4.802-.001 2.4 2.4 0 0 1 4.802 0M13.6 16a2.4 2.4 0 1 1 4.8.001A2.4 2.4 0 0 1 13.6 16m4.8 8.8a2.4 2.4 0 1 1-4.802-.001 2.4 2.4 0 0 1 4.802 0" })
});
export default SvgKebabRegularIcon;
